import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { HttpClient, HttpClientModule } from '@angular/common/http';

import { CommonModule } from '@angular/common';
import { FooterComponent } from '../../../Common/footer/footer.component';
import { HeaderComponent } from '../../../Common/header/header.component';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { RouterLink } from '@angular/router';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.scss'],
  imports: [CommonModule,  ReactiveFormsModule, HttpClientModule, MatSnackBarModule, HeaderComponent, FooterComponent],

  standalone: true,
})
export class ContactUsComponent implements OnInit {
  baseUrl = environment.baseUrl;
  isAppointmentSubmitted: boolean = false; // Used to show success message

  constructor(private http: HttpClient) {}

  ngOnInit(): void {}

  appointmentForm = new FormGroup({
    name: new FormControl('', [Validators.required]),
    email: new FormControl('', [Validators.required, Validators.email]),
    phone: new FormControl('', [
      Validators.required,
      Validators.pattern('^[0-9]*$'),
    ]), // New Phone/WhatsApp field
    appointmentDate: new FormControl('', [Validators.required]), // New Requested Appointment Date field
  });

  onSubmit() {
    if (this.appointmentForm.valid) {
      const appointmentData = {
        full_name: this.appointmentForm.value.name,
        email: this.appointmentForm.value.email,
        phone: this.appointmentForm.value.phone,
        appointment_date: this.appointmentForm.value.appointmentDate,
        loan_type_id: 2, // Setting loan_type_id as 2 (adjust as needed)
        organization_id: 1, // Setting organization_id as 1
        enq_detail_msg: '', // Optional, can modify if needed
      };

      this.http
        .post(`${this.baseUrl}/add_basic_enquiry`, appointmentData)
        .subscribe({
          next: (res: any) => {
            console.log('Response from API:', res);
            if (res.success) {
              console.log('Appointment submission successful!');
              this.appointmentForm.reset(); // Reset form after successful submission
              this.isAppointmentSubmitted = true; // Show success message

              // Automatically hide the success message after 5 seconds
              setTimeout(() => {
                this.isAppointmentSubmitted = false;
              }, 5000);
            } else {
              console.log('Submission failed:', res);
            }
          },
          error: (err: any) => {
            console.log('Error during submission:', err);
          },
        });
    } else {
      console.error('Form is invalid');
    }
  }
}
